module.exports = __webpack_public_path__ + "tab_tujian_selected.png?467cff967dc2930d58847ebc8538d111";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tab_tujian_selected.png
// module id = 135
// module chunks = 0